/**
 *
 * Alerts
 *
 */

import React, { useEffect } from 'react';

import { Box, Stack } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Card, renderSeverityBar, StackedHeader } from 'components/DataDisplay';
import { CustomSpinner } from 'components/DataDisplay/Spinner/CustomSpinner';
import { usePageContentContext } from 'components/Layout';
import { ActiveResourceProvider } from 'containers/ActiveCloudResource/hooks/context/ActiveResourceProvider';
import { AlertDetailsContent } from 'containers/Findings/AlertDrawer/Components/Aggregated/AlertDetailsContent';
import { selectAlertDrawer } from 'containers/Findings/AlertDrawer/selectors';
import { actions } from 'containers/Findings/AlertDrawer/slice';
import { actions as sharedStateActions } from 'containers/SharedState/slice';

export const IndividualAlertDetails = () => {
  const dispatch = useDispatch();
  const { contentHeight } = usePageContentContext();
  const params = useParams<{ id: string }>();
  const { alert } = useSelector(selectAlertDrawer);

  useEffect(() => {
    if (!params?.id) return;
    dispatch(
      actions.getAlertById({
        q: { alertId: params.id },
        onSuccess: res => {
          dispatch(
            sharedStateActions.getRiskContext({
              q: { riskContextRequest: { uuids: [res?.entity_uuid!] ?? [] } },
            }),
          );
        },
      }),
    );
  }, [dispatch, params?.id]);

  return (
    <Card styles={{ card: { h: contentHeight + 'px' } }}>
      {alert.isLoading ? (
        <CustomSpinner />
      ) : (
        <Box w="full" h="full">
          <Stack spacing={8}>
            <StackedHeader
              type={alert.data?.resource!}
              upper={alert.data?.message}
              lower={renderSeverityBar({
                value: alert.data?.severity,
                labelStyles: {
                  fontSize: 'md',
                },
              })}
              size="md"
              isLoading={alert.isLoading}
            />
            <ActiveResourceProvider>
              <AlertDetailsContent alert={alert.data} />
            </ActiveResourceProvider>
          </Stack>
        </Box>
      )}
    </Card>
  );
};
